import { Flame, Info } from "lucide-react";
import { Link } from "react-router-dom";

export const STORE_CATEGORIES = ["Candy", "Sensory", "Toys", "Charms & Accessories", "Mini Add-Ons", "Seasonal"];

const slug = (c) => c.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function CategoryBar({ active }) {
  return (
    <nav data-testid="category-bar" aria-label="Shop categories" className="border-b-2 border-[#0A0A0A] bg-[#0A0A0A]">
      <div className="mx-auto flex max-w-7xl items-center gap-1 overflow-x-auto px-5 py-2 sm:px-8 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <Link
          to="/category/trending"
          data-testid="category-bar-trending"
          className={`flex shrink-0 items-center gap-1.5 rounded-full border-2 px-4 py-1.5 font-display text-sm font-black uppercase tracking-wide transition-colors ${
            active === "Trending"
              ? "border-[#FFD700] bg-[#FF2A54] text-white"
              : "border-transparent bg-gradient-to-r from-[#FF2A54] to-[#FF7A00] text-white hover:border-[#FFD700]"
          }`}
        >
          <Flame className="h-4 w-4 text-[#FFD700]" /> Trending
        </Link>
        {STORE_CATEGORIES.map((c) => (
          <Link
            key={c}
            to={`/category/${slug(c)}`}
            data-testid={`category-bar-${slug(c)}`}
            className={`shrink-0 whitespace-nowrap rounded-full border-2 px-4 py-1.5 font-display text-sm font-black uppercase tracking-wide transition-colors ${
              active === c
                ? "border-[#0A0A0A] bg-[#FFD700] text-[#0A0A0A]"
                : "border-transparent text-white hover:border-[#FFD700] hover:text-[#FFD700]"
            }`}
          >
            {c}
          </Link>
        ))}
        <Link
          to="/about"
          data-testid="category-bar-about"
          className="ml-auto flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border-2 border-transparent px-4 py-1.5 font-display text-sm font-black uppercase tracking-wide text-[#FFD700] transition-colors hover:border-[#FFD700]"
        >
          <Info className="h-3.5 w-3.5" /> About Us
        </Link>
      </div>
    </nav>
  );
}
